export interface DocumentListType {
  documentsArray: DocumentItem[];
}

export interface DocumentItem {
  id: string;
  fileName: string;
  policyNumber: string;
  fileUrl: string;
}

export type PolicyDetailsResponseType = {
  response: {
    coverageLimitsArray: any[];
    deductiblesArray: any[];
    policyholdersArray: any[];
    mailingAddress: string;
  };
  property: {
    surchargeList: any;
  };
};

export const toDocumentsList = (documets: any) => {
  if (!documets || documets.length == 0) {
    return [];
  } else {
    return documets.map((documentItem: any) => ({
      id: documentItem?.id ?? "",
      fileName: documentItem?.fileName ?? "",
      policyNumber: documentItem?.policyNumber ?? "",
      fileUrl: documentItem?.fileUrl ?? "",
    }));
  }
};
